const examRoutes = [
  {
    path: '/exames',
    name: 'exams-list',
    component: () => import('@/views/ExamsList.vue'),
    meta: {
      header: {
        hidePreviousBtn: false,
        title: 'Confira seus serviços',
      },
    },
  },
  {
    path: '/enviar-exames',
    name: 'send-exams',
    component: () => import('@/views/sendExams/sendExams.view.vue'),
    meta: {
      header: {
        hidePreviousBtn: false,
        title: 'Pedido médico'
      }
    }
  },
  {
    path: '/enviar-pedido-medico',
    name: 'upload-medical-order',
    component: () => import('@/views/sendExams/uploadMedicalOrder.view.vue'),
    meta: {
      header: {
        hidePreviousBtn: false,
        title: 'Pedido médico'
      }
    }
  },
  {
    path: '/enviar-exames/feedback',
    name: 'exams-skip',
    component: () => import('@/views/sendExams/skipSendExams.view.vue'),
    meta: {
      header: {
        hidePreviousBtn: false,
        title: 'Adicione seus serviços'
      }
    }
  },
  {
    path: '/selecao-exames',
    name: 'search-exams',
    component: () => import('@/views/searchExams/searchExams.view.vue'),
    meta: {
      header: {
        hidePreviousBtn: false,
        title: 'Adicione seus exames',
        fixed: true
      }
    },
  },
  {
    path: '/selecao-exames/carrinho',
    name: 'cart',
    component: () => import('@/views/searchExams/cart.view.vue'),
    meta: {
      header: {
        hidePreviousBtn: false,
        title: 'Exames adicionados',
        fixed: true
      }
    },
  },
  {
    path: '/adicionar-exames/verificacao',
    name: 'add-exams-check',
    component: () => import('@/views/addExams/addExamsCheck.view.vue'),
    meta: {
      header: {
        hidePreviousBtn: false,
        title: 'Confira seus serviços',
      },
    },
  },
  {
    path: '/adiconar-exames/guiche',
    name: 'add-exams-service-desk',
    component: () => import('@/views/addExams/addExamsServiceDesk.view.vue'),
    meta: {
      header: {
        hidePreviousBtn: false,
        title: 'Atendimento no guichê',
      },
    },
  },
];

export default examRoutes;
